import type { App } from '../app/App';
import type { DioramaView } from '../game/views/dioramas/DioramaView';

export function exitToMainMenu(app: App, dioramaView?: DioramaView): void {
  app.controller.launchMainMenuScene(dioramaView);
}
